import * as React from 'react';
import { css } from 'aphrodite';

import styles from './SVGStyles';

export default class HeloanSVG extends React.PureComponent {
  render() {
    return (
      <svg
        className={css(styles.width)}
        height="100px"
        viewBox="0 0 100 100"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <g id="illustration_construction" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path
            d="M44,75 L44,55 L31,55 L31,75 L44,75 Z M48,75 L72,75 L72,79 L10,79 L10,75 L27,75 L27,55 L10,55 L10,51 L17,51 L31,36 L36,36 L22,51 L28,51 L42,36 L47,36 L33,51 L39,51 L53,36 L58,36 L44,51 L48,51 L48,55 L48,75 Z"
            id="Combined-Shape"
            className={css(styles.grey)}
          />
          <g
            id="Group"
            transform="translate(82.422229, 38.026820) rotate(11.000000) translate(-82.422229, -38.026820) translate(64.922229, 21.026820)"
          >
            <path
              d="M15.6823266,10 L12,13.5957285 L13.3094705,15 L17,11.3966438 C16.5988069,10.9832189 15.8314691,10.1662853 15.6823266,10"
              id="Fill-10"
              className={css(styles.actionAccent)}
            />
            <path
              d="M13,14.7121126 L30.5634026,33.3355397 C31.3163971,34.1346969 32.5033338,34.2258496 33.214409,33.5390616 L34.4875131,32.3085009 C35.1962595,31.6232846 35.1667607,30.4257275 34.4184239,29.6257845 C30.6487938,25.5962092 20.0727143,14.3027116 16.8410482,11 L13,14.7121126 Z"
              id="Fill-11"
              className={css(styles.action)}
            />
            <path
              d="M20.1525632,0.994046293 C17.6494337,-0.0353964281 14.9369968,-0.122891177 13.1761693,0.100969262 C11.9047631,0.262558663 9.41097073,1.27781305 7.80576209,2.82985954 L4.36736317,6.15544823 C4.22263762,6.29575513 4.21796906,6.52434501 4.32768036,6.71825229 C4.63191525,7.25740913 4.57900483,7.92268451 4.1564996,8.33099334 C3.73477247,8.73851393 3.07728274,8.76137292 2.55907191,8.42873522 C2.37232927,8.30813435 2.14668191,8.30261667 2.00195636,8.44292356 L0.318938284,10.0706412 C-0.124575494,10.4994443 -0.102788853,11.2506379 0.367180133,11.7495945 L3.03993422,14.5856855 C3.5099032,15.0846421 4.24987093,15.1406072 4.69260661,14.7118041 L6.37562468,13.0848747 C6.52035023,12.9445678 6.52579689,12.7159779 6.41608559,12.5220706 C6.1118507,11.9813373 6.16476111,11.3176384 6.58648825,10.9093296 C7.11092384,10.4024906 8.32941959,9.7324858 10.4069315,11.8969955 L11.9989125,13.4640186 L15.8411424,9.74825062 C14.6576609,8.44213532 13.7970886,7.3992925 13.6694811,6.52434501 C13.5084156,5.41686644 13.5496546,4.12336299 14.9183225,3.3445809 C16.7732994,2.29070271 18.5473546,2.54609278 19.8428816,2.52481028 C21.7336509,2.49564536 20.9104271,1.30618972 20.1525632,0.994046293"
              id="Fill-12"
              className={css(styles.grey)}
            />
          </g>
          <path
            d="M66.218,35.976231 L62.734,32.144231 C62.413,31.790231 61.867,31.765231 61.514,32.085231 C61.162,32.406231 61.135,32.952231 61.456,33.305231 L62.618,34.582231 L58,38.605231 L59.161,39.882231 L63.779,35.860231 L64.941,37.138231 C65.261,37.491231 65.807,37.516231 66.16,37.196231 C66.513,36.875231 66.539,36.330231 66.218,35.976231"
            id="Fill-16"
            className={css(styles.action)}
          />
          <path
            d="M67,51 L53,36 L58,36 L72,51 L72,55 L72,79 L68,79 L68,55 L55,55 L55,79 L51,79 L51,55 L38,55 L38,79 L34,79 L34,52.5766527 L24,41.862367 L14,52.5766527 L14,79 L10,79 L10,51 L24,36 L38,51 L45,51 L31,36 L36,36 L50,51 L56,51 L42,36 L47,36 L61,51 L67,51 Z"
            id="Combined-Shape"
            className={css(styles.actionAccent)}
          />
        </g>
      </svg>
    );
  }
}
